<template>
    <div class="p-2 text-center font-sans text-gray-300 md:p-4">
    
        <BuyerSellerVanguard />

      <h1 class="text-3xl mt-6">How <span class="text-red-500">V</span>A Protects its Sellers</h1>
    

    
    <p class="w-5/6 m-auto md:w-1/2">We know it can be difficult to trust a service like this, so we've put a lot of protections in place for our Sellers.</p>


<h1 class="text-3xl mt-6">Attracting High-Quality Buyers</h1>
<p class="w-5/6 m-auto md:w-1/2">Our service comes with extra fees for new Buyers, so you know that any customers you get are genuinely interested in paying for the product.</p>
<p class="w-5/6 m-auto md:w-1/2 mt-2">We've made our policies such that a First-Time Buyer buying from a First-Time Seller is discouraged, but if it happens it will be extremely secure nevertheless.</p>
<p class="w-5/6 m-auto md:w-1/2 mt-2">This also means that the more you use this website as a Seller, the more traffic you will receive from Buyers.</p>

<h1 class="text-3xl mt-6">Protecting Against Buyer Fraud</h1>
<p class="w-5/6 m-auto md:w-1/2">Unlike any other similar service, our focus on <span class="font-valorant text-red-500">vAlorant</span> accounts let's us create a specialized anti-fraud system.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">For starters, we ask for a picture of the account's match history right before the account is put up. This is to prevent a Buyer from deranking your account, and claiming the difference in rank as a discrepancy.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">In addition, every listing <span class="text-red-500">MUST</span> contain information about CPU, GPU, and Region <span class="text-red-500">at the minimum.</span> Not only does this protect Sellers from fraud, it also protects Buyers from buying accounts that are incompatible.</p>

<h1 class="text-3xl mt-6">Your Bag is Secure</h1>
<p class="w-5/6 m-auto md:w-1/2">The only way for a Buyer to see account information is if their payment has made it to us with at least 3 confirmations.</p>
<p class="w-5/6 m-auto mt-2 md:w-1/2">We believe that this, combined with restrictions in place for new Buyers, will drive any scammers away from the platform.</p>

</div>
</template>

<script>
import BuyerSellerVanguard from './BuyerSellerVanguard'

export default {
  name: 'ProtectSellers',
  data() {
    return {

    }
  },
  components: {BuyerSellerVanguard},  
 beforeMount(){

 },    

}
</script>



// WEBPACK FOOTER //
// src/components/ProtectSellers.vue